module.exports = __webpack_public_path__ + "img/bike.5e2f8bb4.svg";